import Vue from 'vue';
import Router from 'vue-router';
import MainLayout from '../layouts/MainLayout.vue';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import Merchants from '../views/Merchants.vue';
import { getToken } from '../utils/auth';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/login', component: Login },
    {
      path: '/',
      component: MainLayout,
      children: [
        { path: 'dashboard', component: Dashboard },
        { path: 'merchants', component: Merchants }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  if (to.path !== '/login' && !token) return next('/login');
  if (to.path === '/login' && token) return next('/dashboard');
  return next();
});

export default router;

